/**
 * @fileoverview POST handler for the "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/post_launch_draft" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftCacheKeys } from "./constants";
import type {
  PostEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftProps,
  PostLandingPagePostLaunchDraftResult,
  PostLandingPagePostLaunchDraftResultErrors,
} from "./types";

export const postLandingPageSavePostLaunchDraft = reactQueryMutationAdapter(
  postEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostLandingPagePostLaunchDraftResultErrors>()(
    ({
      appGroupId,
      landingPageBsonId,
      postLaunchDraftId,
      name,
      description,
      slug,
      siteName,
      siteDescription,
      faviconUrl,
      faviconUrlIsCustom,
      grapesJsData,
      html,
      surveyDefinition,
    }: PostEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftProps): Promise<PostLandingPagePostLaunchDraftResult> => {
      return fetch(
        `/engagement/landing_pages/${appGroupId}/${landingPageBsonId}/post_launch_draft`,
        "POST",
        {
          post_launch_draft_id: postLaunchDraftId,
          ...(name !== undefined && { name }),
          ...(description !== undefined && { description }),
          ...(slug !== undefined && { slug }),
          ...(siteName !== undefined && { site_name: siteName }),
          ...(siteDescription !== undefined && { site_description: siteDescription }),
          ...(faviconUrl !== undefined && { favicon_url: faviconUrl }),
          ...(faviconUrlIsCustom !== undefined && { favicon_url_is_custom: faviconUrlIsCustom }),
          ...(grapesJsData !== undefined && { grapes_js_data: grapesJsData }),
          ...(html !== undefined && { html }),
          ...(surveyDefinition !== undefined && { survey_definition: surveyDefinition }),
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
